import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SessionFacade } from '@mode/sessions/domain';

const SESSION_POLL_URL = /\/sessions\/active(?:[/?].*)?$/i;

// Set only by the auth layer (require_api_user) when a request fails because the
// session/cookie is no longer valid - distinguishes it from resource-level 401s
// (e.g. a wrong access-token password) that are not session expiry.
const SESSION_EXPIRED_HEADER = 'X-Session-Expired';

/**
 * Surfaces the "you've been signed out" dialog as soon as an API call fails
 * with a genuine session-expiry 401, instead of waiting for the next session
 * poll tick.
 */
@Injectable()
export class SessionExpiredInterceptor implements HttpInterceptor {
  constructor(private sessionFacade: SessionFacade) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (SESSION_POLL_URL.test(request.url)) {
      return next.handle(request);
    }

    return next.handle(request).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse && error.status === 401 && error.headers.has(SESSION_EXPIRED_HEADER)) {
          this.sessionFacade.updateSessionState({ active: false });
        }

        return throwError(() => error);
      })
    );
  }
}
